import { render, staticRenderFns } from "./JsonEditor.vue?vue&type=template&id=ae12b6fe&scoped=true&"
import script from "./JsonEditor.vue?vue&type=script&lang=js&"
export * from "./JsonEditor.vue?vue&type=script&lang=js&"
import style0 from "./JsonEditor.vue?vue&type=style&index=0&id=ae12b6fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae12b6fe",
  null
  
)

export default component.exports